export default __webpack_public_path__ + "static/media/bk-hossain-cover.e8f3be92.png";